package `fun`.adaptive.runtime

enum class ApplicationNodeType {
    Client,
    Server
}